import { useMediaQuery } from "@mui/material";
import {
  SimpleShowLayout,
  ArrayField,
  Datagrid,
  TextField,
  ReferenceField,
  useRecordContext,
  Labeled,
} from "react-admin";
import { Grid, Box } from "@mui/material";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { administrationRequests } from "api/administrationApi";

const MobileTaxesList = () => {
  const record = useRecordContext();

  if (!record?.taxes?.length) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      {record.taxes.map((item, index) => (
        <Box
          key={index}
          display="flex"
          flexDirection="column"
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            boxShadow: 1,
            backgroundColor: "#fff",
          }}
        >
          <Labeled label="Тип такса">
            <ReferenceField
              source="taxTypeId"
              record={item}
              reference={administrationRequests.getTaxTypesSelect()}
              sortable={false}
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </Labeled>

          <Labeled label="Стойност">
            <TextField
              source="price"
              record={item}
            />
          </Labeled>
        </Box>
      ))}
    </Box>
  );
};

const TaxesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Такси"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <ArrayField source="taxes">
            {isMobile ? (
              <MobileTaxesList />
            ) : (
              <Datagrid
                bulkActionButtons={false}
                rowClick={false}
                sx={settings.style.detailsDatagrid}
              >
                <ReferenceField
                  source="taxTypeId"
                  reference={administrationRequests.getTaxTypesSelect()}
                  label="Тип такса"
                  sortable={false}
                  link={false}
                >
                  <TextField source="name" />
                </ReferenceField>

                <TextField
                  source="price"
                  label="Стойност"
                />
              </Datagrid>
            )}
          </ArrayField>
        </Grid>
      </Grid>
    </SimpleShowLayout>
  );
};

export default TaxesSection;
